document.addEventListener("DOMContentLoaded", function() {
  const container = document.querySelector(".shop-the-look-container");
  if (!container) return;

  const toggle = container.querySelector(".stl-toggle-input");
  const lookSection = container.querySelector(".stl-look-section");
  const recSection = container.querySelector(".stl-rec-section");

  if (toggle) {
    toggle.addEventListener("change", function() {
      const showRec = this.checked;
      lookSection.style.display = showRec ? "none" : "block";
      recSection.style.display = showRec ? "block" : "none";
    });
  }

  const lookSplide = container.querySelector(".stl-look-section .splide");
  if (lookSplide) {
    new Splide(lookSplide, {
      type: "loop",
      perPage: 2,
      perMove: 1,
      gap: "16px",
      arrows: true,
      pagination: false,
      breakpoints: { 640: { perPage: 1 } },
    }).mount();
  }

  const recSectionEl = container.querySelector(".stl-rec-section");
  if (recSectionEl) {
    const observer = new MutationObserver((mutations, obs) => {
      const recSplide = recSectionEl.querySelector(".splide");
      const recSlides = recSplide?.querySelectorAll(".splide__slide");
      if (recSplide && recSlides && recSlides.length > 0) {
        new Splide(recSplide, {
          type: "loop",
          perPage: 2,
          perMove: 1,
          gap: "16px",
          arrows: true,
          pagination: false,
          breakpoints: { 640: { perPage: 1 } },
        }).mount();
        obs.disconnect();
      }
    });
    observer.observe(recSectionEl, { childList: true, subtree: true });
  }
});